import React from "react";
import { ResourceMaterial } from "../types/resource.types";

interface ResourceMaterialItemProps {
  material: ResourceMaterial;
}

export const ResourceMaterialItem: React.FC<ResourceMaterialItemProps> = ({
  material,
}) => {
  // Determine if the material has a file or URL
  const hasFile = !!material.resourceFile && material.resourceFile.length > 0;
  const hasUrl = !!material.resourceUrl;
  const hasImage = !!material.image && material.image.length > 0;

  // Get file URL if available
  const getFileUrl = (): string | undefined => {
    if (hasUrl) {
      return material.resourceUrl;
    }
    if (
      hasFile &&
      material.resourceFile[0].variants &&
      material.resourceFile[0].variants.length > 0
    ) {
      return material.resourceFile[0].variants[0].url;
    }
    return undefined;
  };

  // Get image URL if available
  const getImageUrl = (): string | undefined => {
    if (
      hasImage &&
      material.image[0].variants &&
      material.image[0].variants.length > 0
    ) {
      return material.image[0].variants[0].url;
    }
    return undefined;
  };

  return (
    <>
      <div className="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden bg-white dark:bg-gray-800 relative">
        <div className="p-4">
          {/* Material header */}
          <div className="flex justify-between items-start">
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
              {material.category}
            </span>
          </div>
          {/* Material image */}
          {hasImage && (
            <div className="mt-4">
              <img
                src={getImageUrl()}
                alt={material.title || "Material image"}
                className="w-full h-auto rounded-md object-cover aspect-[4/5]"
              />
            </div>
          )}

          {/* Material status */}
          {material.status && (
            <div className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Status: <span className="font-medium">{material.status}</span>
            </div>
          )}
        </div>
        {/* Hover overlay for downloadable/clickable items */}
        {(hasUrl ||
          (material.resourceFile && material.resourceFile.length > 0)) && (
          <div
            className="absolute inset-0 bg-[#ff8138] bg-opacity-50 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity duration-300 cursor-pointer"
            onClick={() => {
              if (hasUrl) {
                window.open(material.resourceUrl, "_blank");
              } else if (
                material.resourceFile &&
                material.resourceFile.length > 0
              ) {
                const fileUrl = getFileUrl();
                if (fileUrl) {
                  window.open(fileUrl, "_blank");
                }
              }
            }}
          >
            <div className="text-white">
              <svg
                className="w-10 h-10 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
              <span className="block mt-2 text-sm font-medium">
                Download / View
              </span>
            </div>
          </div>
        )}
      </div>

      {/* Material header */}
      <div className="flex justify-between items-start mt-4 px-4">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white">
          {material.title}
        </h3>
      </div>
    </>
  );
};
